import React, { Component } from 'react'
import _find from 'lodash/find'

/*
 * Apply to Select components that have value, options and onChange props
 * On component update, if the option associated with the value is disabled
 * change the value to be null
 */
export default function preventSelectConflicts (SelectComponent) {
  return class NoConflictComponent extends Component {
    componentWillUpdate (newProps) {
      let conflict = this.findDisabledValueConflict(newProps)
      if (conflict) {
        this.fixDisabledValueConflict()
      }
    }

    findDisabledValueConflict (newProps) {
      return _find(newProps.options, { value: newProps.value, disabled: true })
    }

    fixDisabledValueConflict () {
      this.props.onChange(null)
    }

    render () {
      return <SelectComponent {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/prevent-select-conflicts/index.js